import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
// import Datetime from 'react-datetime'

// import moment from 'moment'
import InspectionItem from '../InspectionItem'
import { translation } from '../../../../utils/helpers'
// import { renderFullDate } from '../../../../utils/time'
// Constants
import OrderBookingButton from '../../OrderBookingButton'
import { bookOrder } from '../../../../actions/orders'

import LabelWrapper from '../../../../shared/elements/labelWrapper'
import Radio from '../../../../shared/elements/radio'
// import DateTime from '../../../../shared/elements/datetime'
// import DropDown from '../../../../shared/elements/dropDown'
// import Inline from '../../../../shared/elements/inline'
import BookingTimes from '../../../../shared/components/BookingTimes'

class BodyshopBooking extends PureComponent {

  constructor (props) {
    super(props)
    this.state = {
    }
    this.renderContent = this.renderContent.bind(this)
    this.bookOrder = this.bookOrder.bind(this)
  }

  // renderDeadlineDate (name, DictionaryKey, times) {
  //   if (this.props.deadline[name] === '') return null
  //   // Variables
  //   // let date = window.CustomDate(this.state.inspection.Deadline[name])
  //   let date = window.CustomDate(this.props.deadline[name])
  //   let timeString = renderFullDate(date, true, true)
  //   let disabled = this.props.bodyshopBooking.IsBooked || this.props.order.IsReferredOut

  //   // Functions
  //   const onChangeTime = (e) => {
  //     this.props.onChangeTime(e.target.value, name, this.props.isBodyshop)
  //   }
  //   // Return
  //   let timeKey = name + '_' + moment(date).format('DD-MM-YYYY_HH:mm') + '_' + times.length
  //   let inputProps = {
  //     readOnly: true,
  //     disabled: disabled
  //   }
  //   const onDeadlineChange = (e) => {
  //     this.props.onDeadlineChange(e, name, this.props.isBodyshop)
  //   }
  //   return (
  //     <LabelWrapper labelText={translation(DictionaryKey)}>
  //       <Inline>
  //         <DateTime
  //           inputProps={inputProps}
  //           closeOnSelect
  //           dateFormat='DD-MM-YYYY'
  //           timeFormat={false}
  //           value={date}
  //           onChange={onDeadlineChange}
  //         />
  //         <DropDown value={timeString} onChange={onChangeTime} ref={name} key={timeKey}
  //           disabled={disabled}>
  //           {times.map((val, index) => {
  //             return <option key={index} value={val}>{val}</option>
  //           })}
  //         </DropDown>
  //       </Inline>
  //     </LabelWrapper>
  //   )
  // }

  bookOrder (e, BodyShop = false, BookAll = false, DoNotRoute = false) {
    let { order } = this.props
    let routeItem = window.LocalstorageStack.findFirst(['/workscreen', '/orders'])
    this.setState({ updating: true })
    // this.saveWorkcard(e).then((res) => {
    this.props.bookOrder({
      OrderId: order.Id,
      Transport: parseInt(order.Transport),
      BrandName: order.BrandName,
      Model: order.Model,
      BookOnlyBodyShopOrder: BodyShop === true,
      BookAll: BookAll === true
    }).then((res) => {
      // Update order
      this.props.onUpdateOrder(res.data.Order)
      // Toastr
      // window.toastr.success(translation('13416'), translation('13424'))
      this.setState({ updating: false })
      // Go back
      if (this.props.auth.departmentType === 1) {
        if (BodyShop !== false) {
          if (routeItem === null) {
            this.props.router.replace('/orders?orderid=' + order.Id)
          } else if (DoNotRoute !== true) {
            this.props.router.replace(routeItem.pathname + '?orderid=' + order.Id)
          }
        }
      } else {
        if (routeItem === null) {
          this.props.router.replace('/orders?orderid=' + order.Id)
        } else {
          this.props.router.replace(routeItem.pathname + '?orderid=' + order.Id)
        }
      }
      this.props.getInspection()
    }, (err) => {
      this.setState({ updating: false })
      if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
        let errors = err.response.data.Errors
        let errorText = ''
        errors.map((item) => {
          if (item.DictionaryKey !== 0) {
            errorText += `<br />${translation(item.DictionaryKey)}<br />`
          }
        })
        // Toastr
        window.toastr.error(translation(errorText), translation('216'))
      } else {
        // Toastr
        window.toastr.error(translation(13417), translation('216'))
      }
      // console.log(res.response.data)
      // Toastr
      // window.toastr.error(translation('13417'), translation('216'))
    })
  }

  renderPaintShopStatus () {
    const onUpdateOrder = (e) => {
      this.props.onUpdateOrder(e)
      this.props.getInspection()
    }
    return (
      <LabelWrapper labelText={translation('13052')}>
        <OrderBookingButton disabled={this.props.order.IsReferredOut} order={this.props.order} bookOrder={this.bookOrder} onUpdateOrder={onUpdateOrder} togglePopup={this.props.togglePopup} />
      </LabelWrapper>
    )
  }

  // renderBookingTimes () {
  //   return(
  //     <BookingTimes OrderId={this.state.order.Id} FromBody />
  //   )
  // }
  renderContent () {
    if (!this.props.order.HasAvailablePaintPartner) return null
    let disabled = this.props.bodyshopBooking.IsBooked || this.props.order.IsReferredOut
    let listItems = [{ id: 1, name: 154 }, { id: 3, name: 26 }, { id: 2, name: 351 }]
    let value = 'Transport'
    let displayValue = this.props.bodyshopBooking[value]
    const onChangeTransport = (e) => {
      this.props.onInputChange(e)
    }
    const renderItem = (val, index) => {
      let id = val.id
      let checked = displayValue !== null && displayValue.toString() === id.toString()
      return (
        <Radio key={index} labelText={translation(val.name)} id={value + '_' + id + '_input'} name={value} value={id} onChange={onChangeTransport} checked={checked} disabled={disabled} />
      )
    }
    const onChangeLoosePart = (e) => {
      this.props.onInputChange(e)
    }
    const renderLoosePart = (val, index) => {
      let id = val.id
      let value = 'LoosePartsType'
      let displayValue = this.props.bodyshopBooking[value]
      let checked = id === 1 && displayValue || id === 2 && !displayValue
      return (
        <Radio key={index} labelText={translation(val.name)} id={value + '_' + id + '_input'} name={value} value={id} onChange={onChangeLoosePart} checked={checked} disabled={disabled} />
      )
    }
    let loosePartTypes = [{ id: 1, name: 75 }, { id: 2, name: 76 }]
    const renderLoosePartType = () => {
      return (
        <LabelWrapper labelText={translation('13395')}>
          {loosePartTypes.map(renderLoosePart)}
        </LabelWrapper>
      )
    }
    const renderTransport = () => {
      if (!this.props.order.Id) return null
      return (
        <LabelWrapper labelText={translation('26')}>
          {listItems.map(renderItem)}
        </LabelWrapper>
      )
    }
    // let deadlineTimes = this.props.deadlineTimes
    return (
      <div>
        {this.renderPaintShopStatus()}
        {<BookingTimes OrderId={this.props.order.Id} FromPaint Component='OrderInspection' />}
        {/* this.renderDeadlineDate('Pickup', 14814, deadlineTimes.PickupTimes)}
    {this.renderDeadlineDate('Delivery', 14815, deadlineTimes.DeliveryTimes) */}
        {renderTransport()}
        {this.props.bodyshopBooking.Transport === 2 && renderLoosePartType()}
      </div>
    )
  }
  render () {
    if (!this.props.deadline) return null
    let title = {
      icon: '/images/svgs/inspection/booking.svg',
      text: '13373'
    }
    const headerClick = () => {
      this.props.onHeaderClick('BodyshopBooking')
    }
    return (
      <InspectionItem title={title} renderContent={this.renderContent} checked={this.props.checked} onHeaderClick={headerClick} />
    )
  }
}

BodyshopBooking.defaultProps = {
  isBodyshop: false
}

BodyshopBooking.propTypes = {
  getInspection: PropTypes.func.isRequired,
  // bodyshopBooking: React.PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onDeadlineChange: PropTypes.func.isRequired,
  onChangeTime: PropTypes.func.isRequired,
  // deadline: React.PropTypes.object.isRequired,
  // deadlineTimes: React.PropTypes.object.isRequired,
  onHeaderClick: PropTypes.func.isRequired,
  isBodyshop: PropTypes.bool,
  order: PropTypes.object.isRequired
}

BodyshopBooking.contextTypes = {
  router: PropTypes.object.isRequired
  // t: React.PropTypes.func.isRequired,
  // enum: React.PropTypes.func.isRequired
}
function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
  bookOrder
})(BodyshopBooking)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderInspection/BodyshopBooking/index.js